
<template>
    <section class="overflow-hidden relative">
        <div class="wrap-parallax flex" :style="src!=='' ? `background-image: url(${src});` : '' ">
            <div v-if=" src!=='' " class="img-over -z-1">
            <div class="-z-30">{{textHide}}</div>
                <img :src="src" :alt="alt" >
            </div>
            <div ref="parallax" class="z-10 text-wrap absolute pt-44 bottom-4">
                <slot></slot>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'parallax',
    props: {
        speed: {
            type: Number,
            default: 0.05
        },
        down: {
            type: Boolean,
            default: false,
            required: false
        },
        
        left: {
            type: Boolean,
            default: false,
            required: false
        },
        
        direction: {
            type: String,
            default: 'y',
            required: false
        },
        textHide:{
            type:String,
            default:'',
            required: false
        },
        src:{
            type:String,
            default:'',
            required:false
        },
        alt:{
            type:String,
            default:'',
            required:false
        },
        hp:{
         type: String,
         default: '100vh',
         required: false
        },
        hpm:{
            type: String,
         default: '100vh',
         required: false  
        }
        
    },
    data() {
        return {
            el: null,
            axes: null,
            speedCoeff: null,
            cord: 0
        }
    },
    mounted() {
        this.loadParallax();
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handler);
    },
    methods: {
        loadParallax() {
            this.initDirection();
            this.el = this.$refs.parallax;
            window.addEventListener('scroll', this.handler);
        },
        handler() {
            const rec = this.el.getBoundingClientRect();
            this.cord = rec.top //- (rec.height / 2);
            if( this.cord < 300 ){
                const calc = Math.round( this.cord * this.speedCoeff)
                this.el.style.transform = `translate${this.axes}(${calc}px)`; 
            }
            
            
            
        },
        initDirection() {
            if (this.direction === 'x') {
                this.axes = 'X';
                if (this.left) {
                    this.speedCoeff = -this.speed;
                }
                else {
                    this.speedCoeff = this.speed;
                }
            }
            else if (this.direction === 'y') {
                this.axes = 'Y';
                if (this.down) {
                    this.speedCoeff = -this.speed;
                }
                else {
                    this.speedCoeff = this.speed;
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.wrap-parallax {
    
    background-size:cover;
    height: v-bind(hpm);
    background-repeat: no-repeat;
    background-position: center top;
    width: 100%;
    @screen lg{
        background-size: 100%;
        height: v-bind(hp);
    }
    &:before{
      content:"";
      width:100%;
      height:100%;
      position:absolute;
      top:0;
      bottom:0;
      background:#00000096;
      z-index:5;

    }
    &:hover {
        transition: all 30s;
        background-size: 140%;
    }
}
</style>